import { NgModule } from '@angular/core';
import { StopPropagationDirective } from './stop-propagation.directive';

@NgModule({
  imports: [StopPropagationDirective],
  exports: [StopPropagationDirective],
})
export class StopPropagationModule {}
